export { Logo }

// The vendored Vike hammer logo (packages/dashboard/assets/vike-logo.svg — same file the
// favicon points at, see pages/+config.ts). Rendered as an <img> rather than inlined so the
// SVG's internal gradient IDs can't collide across instances. `vite/client` types the import
// as a hashed URL string.
import logoUrl from '../assets/vike-logo.svg'

function Logo({ size = 28 }: { size?: number }) {
  return <img src={logoUrl} alt="Vike" width={size} height={size} style={{ display: 'block', flexShrink: 0 }} />
}
